export const OPPORTUNITY_ACTIONS = {
    SET_OPPORTUNITY: "SET_OPPORTUNITY",
    SET_IS_LOADING: "SET_IS_LOADING",
}